import PropTypes from 'prop-types';
import { ESTADOS, PROCESOS_ESPECIFICOS, TIPO_MONITOREOS } from 'constants/nombresCatalogos';
import { TERMINADO } from 'constants/downloadStatus';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Button, Input, SelectTamanoPagina, Tooltip } from 'components';
import { DatePicker, message, Select } from 'antd';
import { getAllDownloads, getArchivoDescarga } from 'actions/downloads.actions';
import { selectMenuState } from 'selectors/auth.selector';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import { NOMBRE_MENU_DESCARGAS, NOMBRE_MENU_PERMISO_DESCARGAR } from 'constants/menuNombres';
import { selectDownloadsState } from 'selectors/downloads.selector';
import { PaperClipOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons';
import { DATE_FORMAT_COLUMN_TABLE, DATE_FORMAT_DATE_PICKER } from 'constants/dateFormat';
import { useDebounce } from 'hooks/useDebounce';
import dayjs from 'dayjs';
import { filterList } from 'utils/filterList';
import { selectCatalogByName, selectCatalogs } from 'selectors/catalogos.selectors';
import testigosIcon from 'assets/images/testigo_descarga.svg';
import sabanasIcons from 'assets/images/sabana_descarga.svg';
// import { type } from '@testing-library/user-event/dist/type';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';

const DEBOUNCE_TIME_FILTER = 2000;

export const TablaDescargas = ({ mainFilters }) => {
  const filtersRef = useRef({});
  const [filters, setFilters] = useState({});
  const procesosEspe = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const estados = useSelector(selectCatalogByName(ESTADOS));
  const catMonitoreos = useSelector(selectCatalogByName(TIPO_MONITOREOS));
  const catalogos = useSelector(selectCatalogs);
  const menu = useSelector(selectMenuState);
  // eslint-disable-next-line no-unused-vars
  const [messageApi, contextHolder] = message.useMessage();

  const catalogosStore = {};
  catalogosStore.procesosEspe = procesosEspe;
  catalogosStore.estados = estados;
  catalogosStore.catBeneficiados = catalogos.data.beneficiados;
  catalogosStore.catMonitoreos = catMonitoreos;

  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };
  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    showTotal
  });

  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllDownloads());
  }, []);

  const { loading, data } = useSelector(selectDownloadsState);

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeSelectFilter = (value) => {
    if (value === undefined) {
      delete filtersRef.current.tipoDescarga;
    } else filtersRef.current.tipoDescarga = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeInitDateFilter = (date) => {
    filtersRef.current.fechaInicioPeticionFormat = date;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeEndDateFilter = (date) => {
    filtersRef.current.fechaFinPeticionFormat = date;
    applyFilter({ ...filtersRef.current });
  };

  function downloadBase64File(base64Data, fileName) {
    const linkSource = `data:application/zip;base64,${base64Data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const handleDownloadFile = async (idDescarga, nombreArchivo) => {
    const { success, response } = await dispatch(getArchivoDescarga({ idDescarga }));
    if (response !== null && response !== undefined && success) {
      downloadBase64File(response.data.archivo, nombreArchivo);
    }
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Filtrar"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const tipoDescargaOptions = [
    { idTipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value, tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.label },
    { idTipoDescarga: DOWNLOAD_TYPES.SABANAS.value, tipoDescarga: DOWNLOAD_TYPES.SABANAS.label },
    { idTipoDescarga: DOWNLOAD_TYPES.TODO.value, tipoDescarga: DOWNLOAD_TYPES.TODO.label }
  ];

  const filterSelect = (columnName, lblColumn) => {
    return (
      <label htmlFor={columnName}>
        {lblColumn}
        <Select
          className="buscador-descargas-campo"
          placeholder="Filtrar"
          allowClear
          style={{ width: '100%' }}
          onChange={handleChangeSelectFilter}
          options={tipoDescargaOptions}
          fieldNames={{
            value: 'idTipoDescarga',
            label: 'tipoDescarga'
          }}
        />
      </label>
    );
  };

  const filterInitDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Filtrar"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeInitDateFilter}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filterEndDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Filtrar"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeEndDateFilter}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const renderIcons = (_, row) => {
    const descripcionDesc = row.tipoDescargaDescripcion;
    if (row.estatusDescripcion === TERMINADO.label) {
      if (descripcionDesc === 'Testigos') {
        return (
          <div>
            <img src={testigosIcon} alt="" />
          </div>
        );
      }
      if (descripcionDesc === 'Sábanas') {
        return (
          <div>
            <img src={sabanasIcons} alt="" height="23px" width="23px" />
          </div>
        );
      }
      if (descripcionDesc === 'Todo') {
        return (
          <div style={{ alignContent: 'center' }}>
            <img src={testigosIcon} alt="" style={{ marginRight: '2em' }} />
            <img src={sabanasIcons} alt="" />
          </div>
        );
      }
    }
    return null;
  };

  const renderActions = (value, row) => (
    <div className="actions-container">
      <Tooltip title="Mostrar liga" class="tooltip-acciones" placement="topLeft">
        <Button
          type="primary"
          onClick={() => {}}
          icon={<PaperClipOutlined />}
          ghost
          style={{ display: 'none' }}
        />
      </Tooltip>
      {getMenuPermissions(
        menu,
        NOMBRE_MENU_DESCARGAS,
        NOMBRE_MENU_DESCARGAS,
        NOMBRE_MENU_PERMISO_DESCARGAR
      ) &&
        row.estatusDescripcion === TERMINADO.label && (
          <Tooltip title="Descargar archivos" class="tooltip-acciones">
            <Button
              type="primary"
              onClick={() => {
                handleDownloadFile(row.idDescarga, row.nombreArchivo);
              }}
              icon={<VerticalAlignBottomOutlined />}
              ghost
            />
          </Tooltip>
        )}
    </div>
  );

  const columns = [
    {
      title: filter('folioDescarga', 'ID de descarga:'),
      dataIndex: 'folioDescarga',
      width: '20%',
      key: 'folioDescarga'
    },
    {
      title: filter('nombreArchivo', 'Nombre del archivo:'),
      dataIndex: 'nombreArchivo',
      width: '20%',
      key: 'nombreArchivo'
    },
    {
      title: filterInitDate('fechaInicioPeticionFormat', 'Solicitud:'),
      dataIndex: 'fechaInicioPeticionFormat',
      render: (d) => (d ? d.format(DATE_FORMAT_COLUMN_TABLE) : ''),
      width: '20%'
    },
    {
      title: filterEndDate('fechaFinPeticionFormat', 'Entrega:'),
      dataIndex: 'fechaFinPeticionFormat',
      render: (d) => (d ? d.format(DATE_FORMAT_COLUMN_TABLE) : ''),
      width: '20%'
    },
    {
      title: filter('estatusDescripcion', 'Estatus:'),
      dataIndex: 'estatusDescripcion',
      key: 'estatusDescripcion',
      align: 'center',
      width: '10%'
    },
    {
      title: filterSelect('tipoDescargaDescripcion', 'Incluye:'),
      dataIndex: 'tipoDescargaDescripcion',
      key: 'tipoDescargaDescripcion',
      align: 'center',
      width: '10%',
      render: renderIcons
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      align: 'center',
      width: '5%',
      key: 'actions',
      render: renderActions
    }
  ];

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize }));
  };

  const obtenerFechaInicio = (fecha) => {
    return dayjs(new Date(fecha.$y, fecha.$M, fecha.$D, 0, 0, 0));
  };

  const obtenerFechaFin = (fecha) => {
    return dayjs(new Date(fecha.$y, fecha.$M, fecha.$D, 23, 59, 59));
  };

  const filteredList = useMemo(() => {
    const { idDescarga, tipoMonitoreo, estatus, fechaInicio, fechaFinal, tipoDescarga } =
      mainFilters;
    const filteredData = data.filter((row) => {
      if (idDescarga && Number(row.folioDescarga) !== Number(idDescarga)) return false;
      if (tipoMonitoreo && row.idTipoMonitoreo !== tipoMonitoreo) return false;
      if (estatus !== undefined && estatus !== row.estatus) return false;
      if (fechaFinal && obtenerFechaFin(fechaFinal) <= row.fechaFinPeticionFormat) return false;
      if (fechaInicio && obtenerFechaInicio(fechaInicio) >= row.fechaFinPeticionFormat)
        return false;
      if (tipoDescarga && tipoDescarga !== row.tipoDescarga) return false;
      return true;
    });
    return filteredData;
  }, [data, mainFilters]);

  const dataList = useMemo(() => {
    return filterList(filteredList, filters);
  }, [filteredList, filters]);

  return (
    <div className="tabla-monitoreo">
      <div className="table-header">
        <div>
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            showExcelButton={false}
          />
        </div>
      </div>
      {contextHolder}
      <Table
        bordered={false}
        columns={columns}
        dataSource={dataList}
        pagination={pagination}
        loading={loading}
      />
    </div>
  );
};

TablaDescargas.propTypes = {
  mainFilters: PropTypes.shape({
    fechaFinal: PropTypes.shape({}),
    fechaInicio: PropTypes.shape({}),
    idDescarga: PropTypes.string,
    tipoMonitoreo: PropTypes.number,
    estatus: PropTypes.number,
    tipoDescarga: PropTypes.number
  }).isRequired
};
